<template lang="pug">
div.mb-40
  div.header
    img( src="@/assets/arrow-left.svg" @click="backPage" )
    span.ml-2.text-20-b {{ returnTitle }}
  div.goal-block( v-for="goal in returnGoalList" )
    inactive-goal-block( :goal="goal" :buttonDisabled="true" :iconButton="true" @editGoal="editGoal" @changeUnactiveGoal="changeUnactiveGoal")
  div.add-button
    div.footer.footer-background-white.ios-navbar
      img(src="@/assets/goalIcon/plus.svg")
      span.text-16-b.ml-2( @click="addGoal" ) Добавить цель
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import InactiveGoalBlock from './InactiveGoalBlock.vue';
export default {
  name: 'AllGoals',

  components: {
    InactiveGoalBlock
  }, 

  props: {
    categoryGoals: {
      type: String,
      default: 'all'
    },
    goalUuid: {
      type: String,
      default: ''
    }
  },

  mounted() {
    if(!this.goalList) {
      this.loadGoalList()
    }
  },

  computed: {
    ...mapState('goals', ['goalList', 'unActiveGoalList']),

    returnTitle() {
      return this.categoryGoals == "all" ? "Все цели" : "Неактивные цели"
    },

    returnGoalList() {
      return this.categoryGoals == "all" ? this.goalList : this.unActiveGoalList
    }
  },

  methods: {
    ...mapActions('goals', ['loadGoalList', 'changeActive']),
    ...mapMutations('goals', ['setSelectedGoal']),

    backPage() {
      this.$router.back()
    },

    addGoal() {
      this.$router.push(`/addGoal`)
    },

    editGoal(goal) {
      this.setSelectedGoal(goal)
      this.$router.push(`/addGoal/${goal.uuid}`)
    },

    changeUnactiveGoal(goal) {
      if(this.goalUuid != '') {
        let obj = {activeUuid: this.goalUuid, unactiveUuid: goal.uuid}
        this.changeActive(obj).then(() => {
          this.$router.back()
        })
      }
    }
  }
}
</script>
<style scoped>
.mb-40 {
  margin-bottom: 40px;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 42px;
  padding-left: 8px;
}
.goals-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.goal-block {
  width: 100%;
  padding: 14px 26px 0px 26px
}
.add-button {
  z-index: 200;
  bottom: 0px;
  width: 100%;
  height: auto;
  margin: 35px 0px 0px 0px;
  display: flex;
  justify-content: center;
  padding: 0px 26px;
}
.footer {
  position: fixed;
  box-shadow: 0px -0.1px 2px rgba(128, 128, 128, 0.452);
  z-index: 202;
  bottom: 10px;
  height: 60px;
  width: 90%;
  border-width: 2px;
  border-radius: 16px;
  border: 2px dashed #BFDBFE;
  background: #EFF6FF;
  color: #5365E5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
